import { defineStore } from 'pinia';
import { CommonService } from '~/services/CommonService';
import { GetContractsByCategoryQuery, GetSeoContentRequest, GetSeoContentResponse, GetProductDevelopersAllQuery } from "~/models/common/GetSeoContent";

interface Province {
  id: number;
  name: string;
  districts: District[];
}
interface District {
  id: number;
  name: string;
  provinceId: number;
  province: Province;
  neighbourhoods: Neighbourhood[];
}
interface Neighbourhood {
  id: number;
  name: string;
  district: District;
  districtId: number;
  neighbourhoods: string
  province: Province;
  provinceId: number;
}
export const useMyCommonStore = defineStore({
  id: 'myCommonStore',
  state: () => ({
    provinces: [] as Province[],
    districts: [] as District[],
    productDevelopers: [],
    contractInfoResponse: [],
    contractsByCategoryResponse: [],
    contractsByCategoryResponseBefore: [],
    selectedParentTitle: "",
    selectedParentDescription: "",
    seoContent: {} as GetSeoContentResponse,
    isMenuOpened: false,
    loading: false,

  }),
  getters: {
    getIsMenuOpened(state) {
      return state.isMenuOpened;
    },
    getContractInfo(state) {
      return state.contractInfoResponse;
    },
    getContractsByCategoryResponse(state) {
      return state.contractsByCategoryResponse;
    },
    getContractsByCategoryResponseBefore(state) {
      return state.contractsByCategoryResponseBefore;
    },
    getSelectedParentDescription(state) {
      return state.selectedParentDescription;
    },
    getSelectedParentTitle(state) {
      return state.selectedParentTitle;
    },
    getSeoContent(state) {
      return state.seoContent;
    },
    getLoading(state) {
      return state.loading;
    },
    uniqueCategoryNames(state) {
      const categoriesMap = new Map();
      state.contractInfoResponse.forEach((item: any) => {
        if (item?.categoryName && !categoriesMap.has(item?.categoryName)) {
          categoriesMap.set(item?.categoryName, item?.categorySeoUrl);
        }
      });

      return Array.from(categoriesMap, ([categoryName, categorySeoUrl]) => ({ categoryName, categorySeoUrl }));
    },
  },
  actions: {
    toggleIsMenuOpen() {
      this.isMenuOpened = !this.isMenuOpened;
    },
    setIsMenuOpen(newValue: boolean) {
      this.isMenuOpened = newValue;
    },
    async getProvinces() {
      const commonService = new CommonService();
      if (this.provinces.length > 0) return;
      const response = await commonService.GetProvinceAll()
      if (response.data.isSuccess) {
        this.provinces = response.data.data
        // // gelen illerin hepsini küçük harf yap
        // this.provinces = response.data.data.map((province: any) => {
        //   return { ...province, name: province.name.toLocaleLowerCase('tr') }
        // })
      }
    },
    async getDistricts(provinceId: number) {
      const commonService = new CommonService();
      const response = await commonService.GetDistrictAll({ provinceId })
      if (response.data.isSuccess) {
        this.districts = response.data.data
      }
    },
    async getProductDevelopers(query: GetProductDevelopersAllQuery) {
      const commonService = new CommonService();
      const response = await commonService.GetProductDevelopersAll(query)
      if (response.data.isSuccess) {
        this.productDevelopers = response.data.data
      }
    },
    async getAllContact() {
      const commonService = new CommonService();
      try {
        const res = await commonService.GetAllContract();
        if (res.data.isSuccess) {
          this.contractInfoResponse = res.data.data;

        } else {
          console.log(res);
        }
      } catch (err: any) {
        if (err && err.response) {
          console.log(err.response.message);
        } else if (err && err.message) {
          toast.error(err);
        }
      }
    },
    async getContractsByCategory() {
      return new Promise<void>(async (resolve) => {
        const commonService = new CommonService();
        const exampleQuery = new GetContractsByCategoryQuery();
        try {
          const res = await commonService.GetContractsByCategory(exampleQuery);
          if (res.data.isSuccess) {
            this.contractsByCategoryResponseBefore = JSON.parse(
              JSON.stringify(res.data.data)
            );
            this.contractsByCategoryResponse = res.data.data?.map((e: any) => {
              const seoUrl = e.seoUrl;
              if (e.contracts.length) {
                // e.contracts = e.contracts.filter((element: any) => element.seoUrl !== seoUrl)
              }
              return e;
            });
            resolve();
          } else {
            console.log(res);
          }
        } catch (err: any) {
          if (err && err.response) {
            console.log(err.response.message);
          } else {
            console.log(err ? err.message : "Bir hata oluştu");
          }
        }
      });
    },
    setSelectedParentTitle(newValue: string) {
      this.selectedParentTitle = newValue;
    },
    setSelectedParentDescription(newValue: string) {
      this.selectedParentDescription = newValue;
    },
    async fetchSeoContent(query: GetSeoContentRequest) {
      this.loading = true;
      const commonService = new CommonService();
      try {
        const res = await commonService.GetSeoContent(query);
        if (res.data.isSuccess) {
          if (res.data.isSuccess) {
            this.seoContent = res.data.data;
          } else this.seoContent = new GetSeoContentResponse();
        } else {
          this.seoContent = new GetSeoContentResponse();
        }
      } catch (err: any) {
        if (err.response) {
          console.log(err.response.message);
        } else {
          console.log(err.message);
        }
      } finally {
        this.loading = false;
      }
    },
  },
});